import { useAutocompleteSource } from '@eas/common-web';
import { CalendarTemplateAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useCalendarTemplates() {
  return useAutocompleteSource<CalendarTemplateAutocomplete>({
    url: `${EvidenceApiUrl.CALENDAR_TEMPLATES}/autocomplete`,
  });
}
